$(document).ready(function(){
  $(".sp_main_product_description").addClass("sp_main_product_description_e");
  $(".sp_main_product_description_rm, .sp_main_product_description_hm").click(function(){
    $(".sp_main_product_description_rm").toggleClass("sp_main_product_description_h");
    $(".sp_main_product_description_hm").toggleClass("sp_main_product_description_h");
    $(".sp_main_product_description").toggleClass("sp_main_product_description_e");
  });
  
  $(".sp_mp_accordian_header").click(function(){
    if ($(this).next().hasClass("active")){
      $(this).next().removeClass("active").slideUp(300);
      $(this).find(".sp_mpa_header_icon").addClass("sp_mpa_header_icon_r");
    }
    else {
      $(".sp_mp_accordian_body").removeClass("active").slideUp(300);
      $(".sp_mpa_header_icon").addClass("sp_mpa_header_icon_r");
      $(this).next(".sp_mp_accordian_body").addClass("active").slideDown(300);
      $(this).find(".sp_mpa_header_icon").removeClass("sp_mpa_header_icon_r");
    }
  });
});
